import SortOptionsProjection from './SortOptionsProjection';

export default SortOptionsProjection;
